import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'

import environment from '../environments/pom/Environment'

const mutation = graphql`
  mutation ChangeUserPasswordMutation(
    $companyId: ID!
    $userId: ID!
    $password: String!
  ) {
    Me {
      Company(id: $companyId) {
        User(id: $userId) {
          changePassword(password: $password)
        }
      }
    }
  }
`

export default (variables, accessToken, callBack, errorCallBack) => {
  commitMutation(environment(accessToken), {
    mutation,
    variables,
    onCompleted: callBack,
    onError: errorCallBack,
  })
}
